import { useEffect, useState } from "react";
import api from "api";

export default function useCheckout({ items = [], existingOrderId = null } = {}) {
  const [userProfile, setUserProfile] = useState(null);
  const [billingInfos, setBillingInfos] = useState(null);
  const [orderId, setOrderId] = useState(existingOrderId);
  const [afterBillingInfos, setAfterBillingInfos] = useState('');
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false)
  const [allowProfileInfoUpdate, setAllowProfileInfoUpdate] = useState(true)
    ;

  /* ===============================
     Load profile
  =============================== */
  useEffect(() => {
    const load = async () => {
      const res = await api.get("/user/profile");
      setUserProfile(res.data);
    };
    load();
  }, []);



  useEffect(() => {


  }, [showPaymentLinkModal]);


  useEffect(() => {


  }, [showPaymentModal]);
  /* ===============================
     Init billing from profile
  =============================== */
  useEffect(() => {
    if (!userProfile) return;
    setBillingInfos({
      orderBillingType: "company",
      orderBillingFirstname: userProfile.userFirstname,
      orderBillingLastname: userProfile.userName,
      orderBillingCompany: userProfile.userCompName,
      orderBillingAddress: userProfile.userAddress,
      orderBillingPostcode: userProfile.userPostcode,
      orderBillingCity: userProfile.userCity,
      orderBillingCountry: userProfile.userCountry,
      orderBillingVATNumber: userProfile.userVATNumber,
      orderBillingEmail: userProfile.userEmail,
    });
  }, [userProfile]);

  /* ===============================
     Start flow
  =============================== */
  const startCheckout = () => {
    setAfterBillingInfos('payment');
    setShowBillingModal(true);
  };
  const startPaymentLink = () => {
    setAfterBillingInfos('paymentLink')
    setShowBillingModal(true);
  }
  /* ===============================
     Save billing
  =============================== */
  const handleBillingSave = async (data, saveProfile) => {
    // alert(afterBillingInfos)
    setBillingInfos(data);
    setShowBillingModal(false);
    // TODO: saveProfile si besoin
    let res;
    if (!orderId) {
      res = await api.post("/orders/checkout", {
        items,
        billingInfos: data,
      });
    } else {
      res = await api.put(`/orders/${orderId}/billing`, data);
    }

    if (res && res?.data) {
      setOrderId(res.data.orderId);

      switch (afterBillingInfos) {
        case 'payment':
          setShowPaymentModal(true);
          break;
        case 'paymentLink':

          setShowPaymentLinkModal(true);
          break;
      }
    }

  }


  /* ===============================
     Direct pay existing order
  =============================== */
  const payOrder = (orderId) => {
    setOrderId(orderId);
    setShowPaymentModal(true);
  };
  return {
    billingInfos,
    orderId,
    setOrderId,
    showBillingModal,
    showPaymentModal,
    showPaymentLinkModal,
    startCheckout,
    startPaymentLink,
    afterBillingInfos,
    handleBillingSave,
    payOrder,
    closeBilling: () => setShowBillingModal(false),
    closePayment: () => setShowPaymentModal(false),
    closePaymentLink: () => setShowPaymentLinkModal(false),
  };
}